export default "__VITE_ASSET__C932BPjP__"